var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100vh-100",attrs:{"id":"observeTable"}},[_c('MonitObserveTableMenu',{on:{"methodEnum":_vm.methodEnum}}),_c('MonitObserveTable',{ref:"monitObserveTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }